// extracted by mini-css-extract-plugin
export default {"tabs":"TagsSelectionModal_tabs__PDHd9","tab":"TagsSelectionModal_tab__EKET2","isActiveTab":"TagsSelectionModal_isActiveTab__0w5ci"};